<form [formGroup]="form" (submit)="submitForm()">
  @if (isLoadingStudentInfo) {
    <div class="flex justify-content-center align-items-center p-8">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  } @else {
  <mat-card class="p-4 bg-grey-button form-household-transfer-and-withdrawal-form">
    
    <div class="edit-field my-1">
      <label for="studentName">Student Name</label>
      <input
        id="studentName"
        matInput
        formControlName="studentName"
        aria-readonly="true"
        data-pw="edit_student_name_input"
        data-qa="edit_student_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="studentPID">Student PID</label>
      <input
        id="studentPID"
        matInput
        formControlName="studentPid"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_pid_input"
        data-qa="edit_student_pid_input" />
    </div>

    <div class="edit-field my-1">
      <label for="termName">Term</label>
      <input
        id="termName"
        matInput
        formControlName="termName"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_term_name_input"
        data-qa="edit_term_name_input" />
    </div>

    @if (shouldDisplayCurrentlyAttendingQuestion()) {

      <fieldset class="edit-field__decision my-4 p-3 border rounded">
        <legend class="px-2 font-semibold">
          Is this student still attending {{ context.currentSchoolName }}?
        </legend>
        <mat-radio-group
          id="isStudentStillAttending"
          aria-label="Is this student still attending {{ context.currentSchoolName }}?"
          aria-required="true"
          formControlName="isStudentStillAttending"
          class="mt-2"
          data-pw="radio_is_student_still_attending"
          data-qa="radio_is_student_still_attending">
          <mat-radio-button [value]="true" class="mr-4" data-pw="radio_is_student_still_attending_yes" data-qa="radio_is_student_still_attending_yes">
            Yes
          </mat-radio-button>
          <mat-radio-button [value]="false" data-pw="radio_is_student_still_attending_no" data-qa="radio_is_student_still_attending_no">
            No
          </mat-radio-button>
        </mat-radio-group>
        <cfi-form-inline-error [control]="form.get('isStudentStillAttending')" />
      </fieldset>

      @if (isStudentStillAttending()) {
        <div class="alert-message my-3 p-3" role="alert" data-pw="student_still_attending_message" data-qa="student_still_attending_message">
          <p>The transfer and withdrawal form is not necessary until attendance of current school has ended.</p>
        </div>
      }
    }

    @if (shouldShowWithdrawalForm()) {
      <div class="edit-field my-3">
        <label for="reasonForWithdrawal">Reason for Withdrawal <span class="text-red-500">*</span></label>
        <mat-form-field>
          <mat-select
            id="reasonForWithdrawal"
            placeholder="Please Select"
            formControlName="reasonForWithdrawal"
            data-pw="edit_reason_for_withdrawal_input"
            data-qa="edit_reason_for_withdrawal_input">
            @for (reason of reasons; track reason) {
              <mat-option [value]="reason.withdrawalReasonId">{{ reason?.description }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <cfi-form-inline-error [control]="form.get('reasonForWithdrawal')" />
      </div>

      @if (shouldRequestNewSchool()) {
        <div class="edit-field my-3">
          <label for="transferSchoolId">School Student is Transferring to <span class="text-red-500">*</span></label>
          <mat-form-field>
            <mat-select
              id="transferSchoolId"
              placeholder="Please Select"
              formControlName="transferSchoolId"
              data-pw="edit_transfer_school_input"
              data-qa="edit_transfer_school_input">
              
              <!-- Search Input -->
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="transferSchoolFilterCtrl"
                  placeholderLabel="Search schools..."
                  noEntriesFoundLabel="No schools found">
                </ngx-mat-select-search>
              </mat-option>
              
              <!-- School Options -->
              @for (school of filteredTransferSchools; track school.schoolId) {
                <mat-option [value]="school.schoolId">{{ school.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <cfi-form-inline-error [control]="form.get('transferSchoolId')" />
        </div>

        <div class="edit-field my-3">
          <label for="firstDateOfAttendanceNewSchool">First Date of Attendance <span class="text-red-500">*</span></label>
          <mat-form-field>
            <input
              id="firstDateOfAttendanceNewSchool"
              matInput
              [matDatepicker]="firstPicker"
              formControlName="firstDateOfAttendanceNewSchool"
              data-pw="edit_first_date_of_attendance_new_school_input"
              data-qa="edit_first_date_of_attendance_new_school_input" />
            <mat-datepicker-toggle matSuffix [for]="firstPicker"></mat-datepicker-toggle>
            <mat-datepicker #firstPicker></mat-datepicker>
          </mat-form-field>
          <cfi-form-inline-error [control]="form.get('firstDateOfAttendanceNewSchool')" />
        </div>
      }
    }

    @if (!form.disabled) {
      <mat-card-actions align="end" class="mt-5">
        <button mat-flat-button type="submit" [disabled]="!isFormReady() || isSubmitting" color="primary">
          @if (isSubmitting) {
            <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
          }
          {{ isSubmitting ? 'Submitting...' : 'Submit' }}
        </button>
      </mat-card-actions>
    }
    
  </mat-card>
}
</form>
